module.exports = __webpack_public_path__ + "static/coupon-3c4b74aed314bb6de7ced0264a105876.png";